/*
*   导航菜单组件
*/
import React,{ useState, useEffect } from 'react';
import {  Row, Col, } from 'antd';
import CNF from '../../incs/Config';

import LOGO from '../../images/footer-logo.png';

const NavMenu = (props) => {
    const [scrollY, setScrollY] = useState(0);
    const handleScroll = () => {
        setScrollY(window.scrollY)
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    return (
        <div className='header-nav' style={{ backgroundColor: scrollY>0?'#060E2A': 'rgba(0, 0, 0, 0)', }}>
            <Row><Col offset={4} span={1}>
                    <img src={LOGO} alt='新致腾' style={{ lineHeight: '35px',height: '35px', marginTop: '18px' }}/>
                </Col>
                <Col span={15}>
                <ul>
                    {
                        CNF.navItems.map((item) => {
                            if(item.key === props.m){
                                return  <li key={item.key}><a className='selected' href={'/' + item.key}>{item.label}</a></li>
                            }else{
                                return <li key={item.key}><a href={'/' + item.key}>{item.label}</a></li>
                            }
                        })
                    }
                </ul>
            </Col></Row>
        </div>
    );
};
export default NavMenu;